import React from "react";

import * as Components from "../../components";

export interface RenavigationProps {
    yumSSOId: string
}
export const Renavigation: React.FunctionComponent<RenavigationProps> = (props) => {
    return <Components.LayoutBlock fill className="yum-sso-self-service-message">
        <div>Tracks user was successfully associated with Yum ID "{props.yumSSOId}".</div>
        <div>You will be redirected to Tracks in 5 seconds.</div>
    </Components.LayoutBlock>
}